// extracted by mini-css-extract-plugin
module.exports = {"root":"DashboardContent_root__1oWj0","chartsWrapper":"DashboardContent_chartsWrapper__3eRT1"};